import { render, staticRenderFns } from "./MarketRuleDiv.vue?vue&type=template&id=61978c8a&scoped=true"
import script from "./MarketRuleDiv.vue?vue&type=script&lang=js"
export * from "./MarketRuleDiv.vue?vue&type=script&lang=js"
import style0 from "./MarketRuleDiv.vue?vue&type=style&index=0&id=61978c8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61978c8a",
  null
  
)

export default component.exports